// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"927":"d3b1537e6c063e28","985":"44fc5df81e3f9b8a"}[chunkId] + ".js";
};